<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary">
          <b-row align-v="center">
            <b-col lg="12">
              <h1>
                <feather-icon icon="CalendarIcon" size="30" class="mr-50" />
                {{ form.id ? 'Editar' : 'Cadastrar' }} Semana Epidemiológica
              </h1>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-card>
      <b-form @submit.prevent="save">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nome" label-for="descricao">
              <b-form-input
                id="descricao"
                v-model="form.descricao"
                placeholder="Ex: Semana 01/2024"
                required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Data Início" label-for="dataInicio">
              <flat-pickr
                id="dataInicio"
                v-model="form.dataInicio"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Data Fim" label-for="dataFim">
              <flat-pickr
                id="dataFim"
                v-model="form.dataFim"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mt-2 text-right">
            <b-button
              variant="outline-secondary"
              class="mr-1"
              :to="'/SemanaEpidemiologicaLista'"
            >
              Cancelar
            </b-button>
            <b-button
              type="submit"
              variant="primary"
            >
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import semanaEpidemiologicaService from '@/services/semanaEpidemiologicaService'
import { hideSpinner, showSpinner } from '@/services/spinService'
import {
  BRow, BCol, BCard, BButton, BForm, BFormGroup, BFormInput
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import 'flatpickr/dist/flatpickr.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow, BCol, BCard, BButton, BForm, BFormGroup, BFormInput, flatPickr
  },
  data() {
    return {
      configFlatPickr: { 
        dateFormat: 'Y-m-d', 
        altInput: true,
        altFormat: 'd/m/Y',
        locale: Portuguese 
      },
      form: {
        id: null,
        descricao: '',
        dataInicio: null,
        dataFim: null,
      },
    }
  },
  created() {
    const id = this.$route.params.id
    if (id) {
      this.fetchSemana(id)
    }
  },
  methods: {
    async fetchSemana(id) {
      showSpinner()
      try {
        const data = await semanaEpidemiologicaService.getById(id)
        this.form = {
          ...data,
          dataInicio: data.dataInicio ? data.dataInicio.substring(0, 10) : null,
          dataFim: data.dataFim ? data.dataFim.substring(0, 10) : null,
        }
      } catch (error) {
        console.error(error)
      } finally {
        hideSpinner()
      }
    },
    async save() {
      showSpinner()
      try {
        if (this.form.id) {
          await semanaEpidemiologicaService.update(this.form)
        } else {
          await semanaEpidemiologicaService.create(this.form)
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Salvo com sucesso',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.$router.push('/SemanaEpidemiologicaLista')
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao salvar',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        hideSpinner()
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
